<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <div class="flex-title">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <v-skeleton-loader
        class="skeleton-wrapper sprint-text"
        type="text"
        :loading="isLoading"
        v-if="isLoading"
      ></v-skeleton-loader>
      <h1 class="task-title" v-else>
        Gráfico de Velocidade do Projeto
        <span>{{ nomeProjeto }}</span> <v-icon>mdi-chart-line</v-icon>
      </h1>
    </div>
    <v-divider class="mx-4" inset vertical></v-divider>
    <div v-if="!isLoading">
      <double-bar-chart
        class="bar-chart"
        :dados="dadosGrafico"
        :titulo="`Quantidade`"
        :cor="`#994a39`"
      ></double-bar-chart>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

import DoubleBarChart from '@/components/DoubleBarChart.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    SnackBar,
    DoubleBarChart,
    VSkeletonLoader,
  },
  data() {
    return {
      idProjeto: null,
      nomeProjeto: '',
      dadosGrafico: [],
      isLoading: true,
    };
  },
  created() {
    this.idProjeto = this.$route.params.id;
    this.fetchVelocityData();
  },
  methods: {
    fetchVelocityData() {
      axios
        .get(`${API_URL}/sprints/${this.idProjeto}/velocitychart`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.dadosGrafico = response.data;
          //   this.dadosGrafico = response.data.dados;
          //   this.nomeProjeto = response.data.projeto;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          console.error('Erro ao buscar dados do gráfico');
        });
    },
  },
};
</script>

<style scoped>
.task-title {
  font-size: 22px;
  font-weight: bold;
}
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.skeleton-wrapper {
  width: 50%;
  background: transparent;
}
.sprint-text {
  font-size: 22px;
  font-weight: bold;
}
.task-card-title {
  font-size: 16px;
  margin-bottom: 10px;
}
.flex {
  display: flex;
}
.bar-chart {
  height: 78vh;
}
</style>
